import React from 'react';

const PreferencesHero = () => {
  return (
    <section style={{
      position: 'relative',
      height: 'clamp(380px, 50vh, 560px)',
      overflow: 'hidden',
      background: '#050A12'
    }}>
      {/* Background image */}
      <img
        src="https://img.rocket.new/generatedImages/rocket_gen_img_16210f84f-1772209161640.png"
        alt="Dramatic Norwegian mountain road winding through snow-capped peaks with misty fjord valley below"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 40%',
          filter: 'brightness(0.3) contrast(1.2) saturate(0.6)'
        }} />
      

      {/* Gradient overlays */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(to bottom, rgba(5,10,18,0.2) 0%, rgba(5,10,18,0.9) 100%)'
      }} />
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(135deg, rgba(232,99,10,0.08) 0%, transparent 55%)'
      }} />

      {/* Diagonal accent lines */}
      <div style={{
        position: 'absolute', top: 0, left: '30%', width: '1px',
        height: '100%', background: 'rgba(232,99,10,0.2)',
        transform: 'rotate(5deg)', transformOrigin: 'top center',
        pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute', top: 0, left: '60%', width: '1px',
        height: '100%', background: 'rgba(59,111,212,0.12)',
        transform: 'rotate(-3deg)', transformOrigin: 'top center',
        pointerEvents: 'none'
      }} />

      {/* Large background text */}
      <div style={{
        position: 'absolute', top: '-10px', right: '-20px',
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: 'clamp(160px, 22vw, 300px)',
        fontWeight: 900, color: 'rgba(59,111,212,0.04)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
        letterSpacing: '-0.05em'
      }}>NYH</div>

      {/* Content */}
      <div style={{
        position: 'absolute', inset: 0,
        display: 'flex', alignItems: 'center',
        padding: '0 5%'
      }}>
        <div style={{ position: 'relative', zIndex: 2, maxWidth: '1400px', width: '100%', margin: '0 auto' }}>
          {/* Label */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <div style={{ width: '40px', height: '1px', background: '#E8630A' }} />
            <span style={{
              fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
              color: '#E8630A', letterSpacing: '0.25em', textTransform: 'uppercase'
            }}>NYHETSBREV INNSTILLINGER</span>
          </div>

          {/* Main heading */}
          <div style={{ marginBottom: '6px' }}>
            <div style={{
              fontFamily: 'Impact, Arial Black, sans-serif',
              fontSize: 'clamp(44px, 7vw, 90px)',
              fontWeight: 900, color: '#EEF0F2',
              lineHeight: 0.88, letterSpacing: '-0.03em',
              textTransform: 'uppercase',
              transform: 'rotate(-1.5deg)',
              display: 'inline-block'
            }}>DINE</div>
          </div>
          <div style={{
            fontFamily: 'Georgia, serif',
            fontStyle: 'italic',
            fontSize: 'clamp(36px, 5.5vw, 76px)',
            fontWeight: 700, color: '#E8630A',
            lineHeight: 0.92, letterSpacing: '-0.02em',
            marginBottom: '20px'
          }}>preferanser.</div>

          <p style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: 'clamp(0.9rem, 1.4vw, 1.1rem)',
            color: 'rgba(238,240,242,0.55)',
            lineHeight: 1.65, maxWidth: '440px'
          }}>
            Tilpass nyhetsbrevet ditt — velg frekvens, emner og hold deg oppdatert på det som betyr noe for deg.
          </p>
        </div>
      </div>
    </section>);

};

export default PreferencesHero;